import * as React from 'react';
import MenuItem, { Props as MenuItemProps } from 'components/MenuItem';
import ModalTrigger from 'components/ModalTrigger';

type DefaultProps = {
  disabled: boolean;
};

type Props = {
  modal: React.ReactElement;
  eventKey?: string;
} & DefaultProps &
  MenuItemProps;

class ModalMenuItem extends React.Component<Props> {
  static defaultProps: DefaultProps = {
    disabled: false,
  };

  render() {
    let menuItem = <MenuItem {...this.props}>{this.props.children}</MenuItem>;

    if (!this.props.disabled) {
      menuItem = <ModalTrigger modal={this.props.modal}>{menuItem}</ModalTrigger>;
    }

    return menuItem;
  }
}

export default ModalMenuItem;
